"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RTTI_CoverageEligibilityRequest_Item = void 0;
var t = __importStar(require("io-ts"));
var RTTI_Extension_1 = require("./RTTI_Extension");
var RTTI_positiveInt_1 = require("../Scalar/RTTI_positiveInt");
var RTTI_Element_1 = require("./RTTI_Element");
var RTTI_CodeableConcept_1 = require("./RTTI_CodeableConcept");
var RTTI_Reference_1 = require("./RTTI_Reference");
var RTTI_Quantity_1 = require("./RTTI_Quantity");
var RTTI_Money_1 = require("./RTTI_Money");
var RTTI_CoverageEligibilityRequest_Diagnosis_1 = require("./RTTI_CoverageEligibilityRequest_Diagnosis");
exports.RTTI_CoverageEligibilityRequest_Item = t.recursion('ICoverageEligibilityRequest_Item', function () {
    return t.partial({
        id: t.string,
        extension: t.array(RTTI_Extension_1.RTTI_Extension),
        modifierExtension: t.array(RTTI_Extension_1.RTTI_Extension),
        supportingInfoSequence: t.array(RTTI_positiveInt_1.RTTI_positiveInt),
        _supportingInfoSequence: t.array(RTTI_Element_1.RTTI_Element),
        category: RTTI_CodeableConcept_1.RTTI_CodeableConcept,
        productOrService: RTTI_CodeableConcept_1.RTTI_CodeableConcept,
        modifier: t.array(RTTI_CodeableConcept_1.RTTI_CodeableConcept),
        provider: RTTI_Reference_1.RTTI_Reference,
        quantity: RTTI_Quantity_1.RTTI_Quantity,
        unitPrice: RTTI_Money_1.RTTI_Money,
        facility: RTTI_Reference_1.RTTI_Reference,
        diagnosis: t.array(RTTI_CoverageEligibilityRequest_Diagnosis_1.RTTI_CoverageEligibilityRequest_Diagnosis),
        detail: t.array(RTTI_Reference_1.RTTI_Reference)
    });
});
//# sourceMappingURL=RTTI_CoverageEligibilityRequest_Item.js.map